import { useMediaQuery } from "@mui/material";
import { SimpleDateRange } from "./SimpleDateRange";
import { RangeSelectorToggleable } from "./RangeSelectorToggleable/RangeSelectorToggleable";

export default function RangeSelector({
  autoSubmit,
}: {
  autoSubmit?: boolean;
}) {
  const isPrint = useMediaQuery("print");
  return isPrint ? (
    <SimpleDateRange />
  ) : (
    <RangeSelectorToggleable {...{ autoSubmit }} />
  );
}
